import React from "react";

const SocialPost = ({ platform, content, mediaUrl, thumbnailUrl }) => {
  const platformColors = {
    LinkedIn: "bg-blue-500 text-slate-50",
    Instagram: "bg-pink-500 text-slate-50",
    YouTube: "bg-red-500 text-slate-50",
  };

  const renderMediaContent = () => {
    if (platform === "YouTube") {
      return (
        <a
          href={mediaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          <img
            src={thumbnailUrl}
            alt={`YouTube video thumbnail`}
            className="w-full h-48 object-cover rounded-lg hover:opacity-90 transition-opacity"
          />
          <p className="mt-2 text-blue-500 hover:underline">Watch on YouTube</p>
        </a>
      );
    }

    if (platform === "Instagram" || platform === "LinkedIn") {
      return (
        <img
          src={mediaUrl}
          alt={`Media content from ${platform}`}
          className="w-full h-48 object-cover rounded-lg"
          onError={(e) => {
            e.target.src = "/fallback-image.jpg"; // Fallback-Image anzeigen, falls das Bild nicht geladen wird
          }}
        />
      );
    }

    return <p className="text-[#d0cbb8]0">No media content available.</p>;
  };

  return (
    <div className="border rounded-lg shadow-lg overflow-hidden bg-white">
      {/* Plattform-Header */}
      <div
        className={`p-3 font-bold ${platformColors[platform] || "bg-gray-500 text-slate-50"} uppercase text-center`}
      >
        {platform}
      </div>
      {/* Hauptinhalt */}
      <div className="p-4">
        <p className="text-gray-700 mb-4">{content || "No description available."}</p>
        {renderMediaContent()}
      </div>
    </div>
  );
};

export default SocialPost;